<div fxLayout="row" fxLayoutAlign="start center">
	<div
		class="dot"
		[ngClass]="{ read: notification.isRead, 'not-read': !notification.isRead }"
	></div>
	<!-- <p class="notification-title">{{ notificationTitles[notification.type] }}</p> -->
</div>
<div fxLayout="row" fxLayoutAlign="space-between center">
	<p class="notification-message">
		{{ currentLang === "en" ? notification.textEn : notification.textFr }}
	</p>
	<p class="date">{{ notification.createdDate | date : "MMM dd" }}</p>
</div>
